import { CONFIG } from '../../core/config';
import { HierarchyTemplate } from '../admin/hierarchy-templates/hierarchy-template';
import { OrgTreeNodeType } from '../admin/organizations/org-tree-node-type';
import { TableTemplate } from '../admin/table-attribute-template/table-template';
import { Media } from '../media/media';
import { ViewModel } from '../view-model';
import { AssetFamily } from './asset-family';
import { HierarchyAttributeInput } from './hierarchy-attribute-input';
import { HierarchyItemIntendedMethodology } from './hierarchy-item-intended-methodology';
import { OrgTreeNodeParentHistory } from './org-tree-node-parent-history';
import { PipingLine } from './piping-line';
import { ProtectedEquipment } from './protection/protected-equipment';

export class AssetHierarchyItem implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Asset Hierarchy';
  public readonly apiRoute: string = CONFIG.apiRoutes.hierarchy;

  public orgTreeNodeId: string;
  public orgTreeNodeType: OrgTreeNodeType = OrgTreeNodeType.None;
  public name: string;
  public description: string;
  public parentId: string;

  public modelId: string;
  public hasModelChanged: boolean;

  public assetFamilyId: string;
  public assetFamily: AssetFamily;

  public intendedMethodology: HierarchyItemIntendedMethodology;

  public createdBy: string;
  public creationDate: string;
  public lastModifiedBy: string;
  public lastModifiedDate: string;

  public installationDate: Date;

  public statusId: string;
  public statusName: string;
  public orgTreeNodeTypeName: string;
  public parentName: string;
  public locationDetailsId: string;
  public assetDetailsId: string;
  public componentDetailsId: string;
  public partDetailsId: string;
  public hierarchyTemplateId: string;
  public hierarchyTemplate: HierarchyTemplate;
  public attributes: HierarchyAttributeInput[] = [];
  public media: Media[] = [];
  public isSelected: boolean;
  public erpIdentifier: string;
  public pipingLines: PipingLine[] = [];
  public protectedBy: ProtectedEquipment[] = [];
  public isProtectingLocation: boolean;
  public isProtectingEquipment: boolean;
  public isReplaceable: boolean;
  public parentHistory: OrgTreeNodeParentHistory[] = [];
  public hasMedia: boolean;
  public hierarchyDetails: string;
  public copyOfOrgTreeNodeId: string = null;
  public tableTemplates: TableTemplate[] = [];

  constructor() {
    this.intendedMethodology = HierarchyItemIntendedMethodology.DataGathering;
  }

  public json(): AssetHierarchyItem {
    return this;
  }

  public loadFromJson(data: any): void {
    this.hasModelChanged = false;
    this.loadHeader(data);
  }

  public loadHeader(data: any): void {
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.orgTreeNodeType = data.orgTreeNodeType;
    this.name = data.name;
    this.description = data.description;

    this.assetFamilyId = data.assetFamilyId;

    if (data.assetFamily) {
      this.assetFamily = new AssetFamily();
      this.assetFamily.loadFromJson(data.assetFamily);
    }

    this.intendedMethodology = data.intendedMethodology;

    this.locationDetailsId = data.locationDetailsId;
    this.assetDetailsId = data.assetDetailsId;
    this.componentDetailsId = data.componentDetailsId;
    this.partDetailsId = data.partDetailsId;
    this.parentId = data.parentId;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.installationDate = data.installationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.statusId = data.statusId;
    this.statusName = data.statusName;
    this.orgTreeNodeTypeName = OrgTreeNodeType[data.orgTreeNodeType];
    this.parentName = data.parentName;

    this.hierarchyTemplateId = data.hierarchyTemplateId;

    if (data.hierarchyTemplate) {
      this.hierarchyTemplate = new HierarchyTemplate();
      this.hierarchyTemplate.loadFromJson(data.hierarchyTemplate);
    }

    this.erpIdentifier = data.erpIdentifier;

    if (data.attributes) {
      data.attributes.forEach(attribute => {
        const newAttribute = new HierarchyAttributeInput();

        newAttribute.loadFromJson(attribute);
        this.attributes.push(newAttribute);
      });
    }

    if (data.tableTemplates) {
      data.tableTemplates.forEach(template => {
        if (template && template != null) {
          const newTemplate = new TableTemplate();

          newTemplate.loadFromJson(template);
          this.tableTemplates.push(newTemplate);
        }
      });
    }

    if (data.media) {
      this.media = [];
      data.media.forEach(item => {
        const newMedia = new Media();

        newMedia.loadFromJson(item);
        this.media.push(newMedia);
      });
    }

    this.pipingLines = [];

    if (data.pipingLines) {
      data.pipingLines.forEach(pipingLine => {
        const newPipingLine = new PipingLine();

        newPipingLine.loadFromJson(pipingLine);
        this.pipingLines.push(newPipingLine);
      });
    }

    this.protectedBy = [];

    if (data.protectedBy) {
      data.protectedBy.forEach(protection => {
        const newProtection = new ProtectedEquipment();

        newProtection.loadFromJson(protection);
        this.protectedBy.push(newProtection);
      });
    }

    this.parentHistory = [];

    if (data.parentHistory) {
      data.parentHistory.forEach(history => {
        const newHistory = new OrgTreeNodeParentHistory();

        newHistory.loadFromJson(history);
        this.parentHistory.push(newHistory);
      });
    }

    this.isProtectingLocation = data.isProtectingLocation;
    this.isProtectingEquipment = data.isProtectingEquipment;
    this.isReplaceable = data.isReplaceable;
    this.hierarchyDetails = data.hierarchyDetails;
    this.hasMedia = data.hasMedia;
  }
}
